import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFilterTimeline: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconFilterTimeline"><Path d="M3.5 16.5L6.5016 19.5L9.5 16.5" stroke="currentColor" strokeLinecap="square"/><Path d="M11.502 6.5H20.502" stroke="currentColor" strokeLinecap="square"/><Path d="M15.5 17.5H20.5" stroke="currentColor" strokeLinecap="square"/><Path d="M13.5 12H20.5" stroke="currentColor" strokeLinecap="square"/><Path d="M6.50195 4.5V19" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconFilterTimeline;
